import { Suspense, lazy, type ComponentProps } from 'react'

/**
 * A person's page is opened by one tap — the account row, a friend's face — and carries the editor
 * behind it. Nothing about it belongs in the chunk every page load pays for.
 */
const ProfilePageImpl = lazy(() => import('./ProfilePage').then((m) => ({ default: m.ProfilePage })))

type Props = ComponentProps<(typeof import('./ProfilePage'))['ProfilePage']>

export function ProfilePageLazy(props: Props) {
  return (
    <Suspense fallback={null}>
      <ProfilePageImpl {...props} />
    </Suspense>
  )
}
